module.exports = {
  lg: {
    '店铺': '店铺',
    '商品匹配': '商品匹配',
    '订单': '订单',
    '操作日志': '操作日志',
    '设置': '设置',
    '物流管理': '物流管理',
    '订单字段映射': '订单字段映射',
    '参数设置': '参数设置',
    '用户': '用户',
    '角色': '角色',
    '时间': '时间',
    '用户创建时间': '用户创建时间',
    '是否管理员': '是否管理员',
    '待处理': '待处理',
    '已启用': '已启用',
    '权限': '权限',
    '退出登录': '退出登录',
    '邀请用户': '邀请用户',

    '失败': '失败',
    '成功': '成功',
    '请选择': '请选择',
    '切换语言成功': '切换语言成功',
    '请输入': '请输入',
    '登录': '登录',
    '邮箱': '邮箱',
    '邮件地址': '邮件地址',
    '请输入邮件地址': '请输入邮件地址',
    '密码': '密码',
    '请输密码': '请输密码',
    '忘记密码': '忘记密码',
    '无账号': '无账号',
    '创建新的': '创建新的',
    '发送': '发送',
    '发送成功': '发送成功',
    '使用条款': '使用条款',
    '隐私政策': '隐私政策',
    '重置您的密码': '重置您的密码',
    '确认密码': '确认密码',
    '确定': '确定',
    '您的完整名称': '您的完整名称',
    '邮件地址': '邮件地址',
    '我接受': '我接受',
    '和': '和',
    '创建您的账户': '创建您的账户',
    '注册': '注册',
    '去登录': '去登录',
    '请输入您的完整名称': '请输入您的完整名称',
    '注册成功': '注册成功',
    '请输入密码': '请输入密码',
    '请输入确认密码': '请输入确认密码',
    '创建时间': '创建时间',
    '绑定时间': '绑定时间',
    '开始日期': '开始日期',
    '结束日期': '结束日期',
    '组织名称': '组织名称',
    '查询': '查询',
    '绑定': '绑定',
    '查看详情': '查看详情',
    '查看店铺': '查看店铺',
    '保存': '保存',
    '详情': '详情',
    '订阅到期日': '订阅到期日',
    '订阅订单量': '订阅订单量',
    '已用订单量': '已用订单量',
    '剩余订单量': '剩余订单量',
    '店铺详情': '店铺详情',
    '操作': '操作',
    '店铺名称': '店铺名称',
    '平台类型': '平台类型',
    '状态': '状态',
    'DEAR承运人': 'DEAR承运人',
    '确定要禁用吗': '确定要禁用吗',
    '启用': '启用',
    '已启用': '已启用',
    '是': '是',
    '否': '否',
    '开启': '开启',
    '物流平台': '物流平台',
    '物流平台类型': '物流平台类型',
    '所属物流': '所属物流',
    '物流平台ID': '物流平台ID',
    '物流平台类型ID': '物流平台类型ID',
    '所属物流名称': '所属物流名称',
    '是否默认': '是否默认',
    '确定要设置为默认吗': '确定要设置为默认吗',
    '提示': '提示',
    '商品代码': '代码',
    '未匹配': '未匹配',
    '已匹配': '已匹配',
    '导入': '导入',
    '下载平台商品': '下载平台商品',
    '商品自动匹配': '商品自动匹配',
    '自动匹配tip': '根据:"商品代码"字段做自动匹配，对于已匹配的商品标记匹配状态为"已匹配"，否则为"未匹配"',
    '保存': '保存',
    '平台产品': '平台产品',
    '产品代码': '产品代码',
    '产品内码': '产品内码',
    '产品名称': '产品名称',
    '规格型号': '规格型号',
    'DEAR产品': 'DEAR产品',
    '产品代码': '产品代码',
    '导入': '导入',
    '将文件拖到此处，或': '将文件拖到此处，或',
    '点击上传': '点击上传',
    '提示：仅允许导入': '提示：仅允许导入',
    '下载Excel模板': '下载Excel模板',
    '格式文件': '格式文件',
    '请上传文件': '请上传文件',
    '操作人': '操作人',
    '操作时间': '操作时间',
    '操作描述': '操作描述',
    '参考号': '参考号',
    '订单附加属性': '订单附加属性',
    '平台订单可选字段': '平台订单可选字段',
    '类型': '类型',
    '关联': '关联',
    '买家备注': '买家备注',
    '卖家备注': '卖家备注',
    '买家昵称': '买家昵称',
    '附加属性': '附加属性',
    '下载订单': '下载订单',
    '同步到': '同步到',
    '平台订单编号': '平台订单编号',
    '订单下单日期': '订单下单日期',
    '订单付款日期': '订单付款日期',
    '平台订单状态': '平台订单状态',
    '退款状态': '退款状态',
    '订单金额': '订单金额',
    '实付金额': '实付金额',
    'DEAR订单编号': 'DEAR订单编号',
    'OMS订单状态': 'OMS订单状态',
    '订单下载日期': '订单下载日期',
    '订单详情': '订单详情',
    '商品名称': '商品名称',
    '数量': '数量',
    '总价': '总价',
    '已删除': '已删除',
    '已关闭': '已关闭',
    '已取消': '已取消',
    '取消': '取消',
    '未知': '未知',
    '未付款': '未付款',
    '部分付款': '部分付款',
    '未发货': '未发货',
    '部分发货': '部分发货',
    '已发货': '已发货',
    '已拒收': '已拒收',
    '已寄票': '已寄票',
    '已收票': '已收票',
    '暂停': '暂停',
    '锁定': '锁定',
    '已完成': '已完成',
    '无退款': '无退款',
    '部分退款': '部分退款',
    '全部退款': '全部退款',
    '全部': '全部',
    '未同步到DEAR': '未同步到DEAR',
    '已同步到DEAR': '已同步到DEAR',
    'DEAR中已删除': 'DEAR中已删除',
    'DEAR同步中': 'DEAR同步中',
    '新增店铺': '新增店铺',
    '删除店铺': '删除店铺',
    '未授权': '未授权',
    '已授权': '已授权',
    '已解绑': '已解绑',
    '店铺授权到期日': '店铺授权到期日',
    '店铺授权tip': '授权到期后，只需重新点击授权即可',
    '订购链接': '订购链接',
    '去订购': '去订购',
    '授权链接': '授权链接',
    '店铺授权': '店铺授权',
    '确定要绑定吗': '确定要绑定吗',
    '默认发货仓库': '默认发货仓库',
    '默认退货仓库': '默认退货仓库',
    '默认销售员': '默认销售员',
    '默认客户': '默认客户',
    '默认税率': '默认税率',
    '默认收款退款账户': '默认收款/退款账户',
    '订单表头字段': '订单表头字段',
    '发货处理方式': '发货处理方式',
    '订单自动同步': '订单自动同步',
    '库存自动同步': '库存自动同步',
    '同步所有库存': '同步所有库存',
    '自动同步订单的起始日期': '自动同步订单的起始日期',
    '选择日期': '选择日期',
    '服务费商品映射': '服务费商品映射',
    '默认销售收入科目': '默认销售收入科目',
    '不处理': '不处理',
    '从DEAR推送发货状态到平台': '从DEAR推送发货状态到平台',
    '从平台获取发货状态到DEAR': '从平台获取发货状态到DEAR',
    '确定要退出登录': '确定要退出登录',
    '返回首页': '返回首页',
    '解绑': '解绑',
    '解绑店铺之后,将不能下载新的订单,是否继续': '解绑店铺之后,将不能下载新的订单,是否继续',
    '接受邀请': '接受邀请',
    '请选择匹配关系': '请选择匹配关系',
    '存在未匹配的商品,此商品的订单下载将会收到影响,是否继续': '存在未匹配的商品,此商品的订单下载将会收到影响,是否继续',

    '订单日期': '订单日期',
    '执行日期': '执行日期',
    '同步状态': '同步状态',
    '同步事件': '同步事件',
    '同步日期': '同步日期',
    '详细描述': '详细描述',

    '跳过': '跳过',
    '同步': '同步',
    '同步中': '同步中',
    '待同步': '待同步',

    '下载平台发货信息到DEAR': '下载平台发货信息到DEAR',
    '上传DEAR发货信息到平台': '上传DEAR发货信息到平台',
    '下载订单退货': '下载订单退货',
    '作废销售订单': '作废销售订单',
    '回传平台发货信息到DEAR': '回传平台发货信息到DEAR',
    '订单同步': '订单同步',
    '确定要执行跳过': '确定要执行跳过？',
    '确定要执行同步': '确定要执行同步？',
    '平台订单号': '平台订单号',
    '请选择要跳过的订单': '请选择要跳过的订单',
    '请选择要同步的订单': '请选择要同步的订单',
    '请选择解绑店铺': '请选择解绑店铺',
    '请选择删除店铺': '请选择删除店铺',
    '店铺解绑': '店铺解绑',
    '平台tip': '匹配需要同步的平台订单其他非核心字段到销售附加属性中，匹配后的字段可以自动下载到匹配的销售附加属性字段。',
    '我的订阅': '我的订阅',
    '修改密码': '修改密码',
    '全选': '全选',
    '全不选': '全不选',
    '步骤': '步骤',
    '下载商品匹配列表导入模板': '下载商品匹配列表导入模板',
    '该模板文件包含了导入商品匹配数据所需要的所有字段': '该模板文件包含了导入商品匹配数据所需要的所有字段',
    '复制商品匹配列表到模板': '复制商品匹配列表到模板',
    '分别从DEAR和平台中导出产品列表，将导出文件中的产品复制并粘贴到下载的模板中，确保复制的数据与模板中的列标题匹配': '分别从DEAR和平台中导出产品列表，将导出文件中的产品复制并粘贴到下载的模板中，确保复制的数据与模板中的列标题匹配',
    '为了正确导入数据，请勿修改模板文档中的列标题': '为了正确导入数据，请勿修改模板文档中的列标题',
    '字段说明': '字段说明',
    '字段名称': '字段名称',
    '字段解释': '字段解释',
    '平台商品代码': '平台商品代码',
    '商家用来标识商品的代码': '商家用来标识商品的代码',
    'DEAR商品代码': 'DEAR商品代码',
    'DEAR中产品的物料代码，每个产品的物料代码是唯一的': 'DEAR中产品的物料代码，每个产品的物料代码是唯一的',
    '导入已更新的模板文件': '导入已更新的模板文件',
    '您导入的文件': '您导入的文件必须为Excel文件，文件的名称必须以.xls或.xlsx结尾',
    'DEAR产品代码': 'DEAR产品代码',
    '错误': '错误',
    '将文件': '拖拽文件到此区域，或',
    '点击上传': '点击上传文件',
    '请上传文件': '请上传文件',
    '商品匹配已成功导入': '商品匹配已成功导入',
    '输入并搜索': '输入并搜索',
    '管理员邮箱': '管理员邮箱',
    '是否默认tip': '下载平台发货信息时的默认DEAR承运人',
    '商品全量下载': '商品全量下载',
    '确定要取消匹配吗': '确定要取消匹配吗?',
    'CNY汇率': 'CNY汇率',
    '自动PICKPACK': '自动 PICKPACK',
    '删除商品': '删除商品',
    '请选择删除商品': '请选择删除商品',
    '自动PICKPACKSHIP': '自动 PICKPACKSHIP'
  }
}